module.exports = __webpack_public_path__ + "img/telescope.c26f0ec8.png";